// Generated with util/create-component.js
import React, { useEffect } from 'react'
import Portal from '../Portal/Portal'
import { ModalProps } from './Modal.types'
import Button from '../Button/Button'
import Icon from '../Icon/Icon'
const Modal: React.FC<ModalProps> = ({
    children,
    title,
    canCloseOnEsc = true,
    noTitleBar = false,
    noPadding = false,
    footer,
    onClose,
    width,
    maxWidth,
    height,
    maxHeight,
    show = false,
    className = '',
    effect = null,
    background,
    topOffset,
    closeButton,
}: ModalProps) => {
    const style = {
        width: width || '500px',
        maxWidth: maxWidth || '99%',
        marginTop: topOffset,
    }

    const contentStyle = {
        height: height || 'auto',
        maxHeight: maxHeight || '100%',
        padding: noPadding ? '0' : null,
        background,
    }

    const handleClose = () => {
        if (onClose) {
            onClose()
        }
    }

    if (!show) {
        return null
    }

    const container = document.body
    // const container = document.getElementById('arctradeRelayApp') || document.body

    const classNames = () => {
        const c = ['r-modal-container']
        if (effect) {
            c.push('r-effect-' + effect)
        }
        return c.join(' ')
    }

    useEffect(() => {
        document.onkeydown = function (event: any) {
            var isEscape = false
            if ('key' in event) {
                isEscape = event.key === 'Escape' || event.key === 'Esc'
            } else {
                isEscape = event.keyCode === 27
            }
            if (isEscape && canCloseOnEsc) {
                onClose()
            }
        }
        return () => {
            document.onkeydown = null
        }
    }, [])

    return (
        <Portal container={container}>
            <div data-testid='Modal' className={classNames()}>
                <div className='r-modal-shim' />
                <div style={style} className='r-modal-content-container'>
                    {noTitleBar ? (
                        ''
                    ) : (
                        <div className='r-modal-title-container'>
                            <div className='r-modal-title'>{title}</div>
                            <div className='r-modal-title-buttons'>
                                {closeButton || (
                                    <Button
                                        noPadding
                                        onClick={handleClose}
                                        size='sm'
                                        type='danger'
                                        isDiscreet
                                        label={<Icon type='window-close' />}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                    <div style={contentStyle} className={`r-modal-content ${className}`}>
                        {children}
                    </div>
                    {footer ? <div className={`r-modal-footer `}>{footer}</div> : ''}
                </div>
            </div>
        </Portal>
    )
}

export default Modal
